var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1732 8.55212C23.7599 9.8658 22.7199 10.9195 21.4532 11.3301C19.3865 12.0006 17.4265 11.0838 16.4399 9.48272C16.3599 9.35956 16.3732 9.19528 16.4399 9.07212C17.0132 8.00476 17.3466 6.78685 17.3466 5.47317C17.3466 5.02159 17.3067 4.57005 17.2267 4.14584C17.2 3.99532 17.2533 3.84475 17.36 3.76264C18.0933 3.1058 19.0533 2.73633 20.08 2.73633C22.9066 2.73633 25.1066 5.54159 24.1732 8.55212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.0008 19.4059C28.0008 21.8964 26.6541 23.2647 24.2142 23.2647H22.2674C22.0541 23.2647 21.8808 23.0868 21.8808 22.8541C21.8808 22.7994 21.8809 22.7447 21.8942 22.6899C21.9742 22.2383 22.0008 21.7458 22.0008 21.2395C22.0008 18.6121 21.1341 15.971 19.2674 14.1236C19.2541 14.1099 19.2409 14.0964 19.2275 14.0827C19.1475 14.0143 19.1074 13.9047 19.1074 13.7952C19.1074 13.5626 19.2808 13.3848 19.5075 13.3848H22.1474C26.4674 13.3848 28.0008 16.628 28.0008 19.4059Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.013 10.9474C12.9596 10.9474 15.3463 8.49789 15.3463 5.47368C15.3463 2.44947 12.9596 0 10.013 0C7.06634 0 4.67969 2.44947 4.67969 5.47368C4.67969 8.49789 7.06634 10.9474 10.013 10.9474Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.9999 21.2373C19.9999 24.3573 18.3866 25.9994 15.3332 25.9994H4.66664C1.61332 25.9994 0 24.3573 0 21.2373C0 17.7478 1.91999 13.6836 7.33329 13.6836H12.6666C18.0799 13.6836 19.9999 17.7478 19.9999 21.2373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.97c77db084968346fa1f80a4d8d59732.svg";
export { ForwardRef as ReactComponent };